"use client";

import cn from "clsx";
import Image from "next/image";
import PlayWhiteBlueIcon from "~/icons/play-white-blue.svg";
import Markdown from "@/components/atoms/Markdown";
import addLineBreaks from "@/helpers/addLineBreaks";
import { ModalButton } from "@/components/atoms/ModalButton";
import { IModalActions, ModalTypes } from "@/types/modal";
import { pushToDataLayer } from "@/helpers/gtag";
import { getGlobalStateValue } from "@/context/utils";
import styles from "./styles.module.scss";

const SECTION_NAME = "Explore MasterClasses";

function trackVideoPlay(video) {
  pushToDataLayer({
    event: "play_video_icon_click",
    cta_text: "Play Video",
    section_name: SECTION_NAME,
    page_type: getGlobalStateValue("pageType") || "Home Page",
  });

  window?.webengage?.track("Video Watched", {
    "Video URL": video?.URL,
    "Video Title": video?.Title,
  });
}

export default function VideoCard({ video, isFirst = false }) {
  const poster = video?.PosterImage?.data?.attributes;

  return (
    <div className={styles.card}>
      <ModalButton
        action={IModalActions.OpenModal}
        data={{
          modalType: ModalTypes.VideoPopup,
          modalData: { url: video?.URL },
        }}
        className={styles.imageWrapper}
        ariaLableText={video?.Title || "Play video"}
        handleClickCB={() => trackVideoPlay(video)}
      >
        <img
          src={poster?.url}
          alt={poster?.alternativeText || "MasterClass video thumbnail"}
          className={styles.image}
          loading="lazy"
        />

        <img
          src="https://amityonline.com/_s/Play_Glow_df6af092ad.webp"
          alt="Icon"
          className={styles.playIcon}
          loading="lazy"
        />
      </ModalButton>

      <div className={styles.content}>
        <Markdown
          as="h3"
          className={cn(styles.title,)}
        >
          {video?.Title}
        </Markdown>

        {!!video?.Description && (
          <p className={styles.description}>{video.Description}</p>
        )}

        {!!video?.Name && <p className={styles.name}>{video.Name}</p>}
      </div>
    </div>
  );
}
